// extracted by mini-css-extract-plugin
export var accordions = "Accordions-module--accordions--87548";
export var contained = "Accordions-module--contained--ce273";